// Determine API URL based on current hostname
const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;
  const origin = window.location.origin;
  
  console.log('[API Config] Current hostname:', hostname);
  console.log('[API Config] Current origin:', origin);
  
  // Production domains
  if (hostname === 'dstribute.ai' || hostname === 'www.dstribute.ai') {
    return 'https://api.dstribute.ai';
  }
  
  // Staging/Preview domains (if using Cloudflare preview URLs)
  if (hostname.includes('pages.dev')) {
    return 'https://api.dstribute.ai'; // Use production API for previews
  }
  
  // Local development (any localhost port)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Check if custom port is specified via env variable
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
    console.log('[API Config] Using local API URL:', apiUrl);
    return apiUrl;
  }
  
  // Fallback for unknown environments
  console.warn(`Unknown hostname: ${hostname}, defaulting to production API`);
  return 'https://api.dstribute.ai';
};

export const API_URL = getApiBaseUrl();

export const getApiUrl = (endpoint: string) => {
  return `${API_URL}${endpoint}`;
};

// Debug logging (only in development)
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  console.log('[API Config] Environment:', window.location.hostname);
  console.log('[API Config] API URL:', API_URL);
}